<div [formGroup]="ticketForm">
  <div class="d-flex card list-header flex-row justify-content-between align-items-center detail-header">
    @if (!viewMode) {
      <div class="d-flex justify-content-between align-items-center w-100">
        <label class="fs-20 font-weight-700">
          <img src="assets/img/back-blue.svg" alt="" class="me-2 mb-1 cursor-pointer" (click)="back()">
          {{mode === 'create' ? ('MAIN.CONTENT.TICKETS.CREATE_TICKET' | translate) : ('MAIN.CONTENT.TICKETS.EDIT_TICKET' | translate)}}
        </label>
        @if (mode !== 'create') {
          <button class="v-btn btn btn-primary vsight-button create-button" (click)="saveChanges()">{{ 'MAIN.CONTENT.TICKETS.SAVE_CHANGES' | translate }}</button>
        }
        @if (mode === 'create') {
          <button class="v-btn btn btn-primary vsight-button create-button" (click)="createTicket()">{{ 'MAIN.CONTENT.TICKETS.CREATE' | translate }}</button>
        }
      </div>
    }
    @if (viewMode) {
      <div class="d-flex justify-content-between align-items-center w-100 detail-header-row">
        <label class="fs-20 font-weight-700 detail-title">
          <img src="assets/img/back-blue.svg" alt="" class="me-2 mb-1 cursor-pointer" (click)="back()">
          {{selectedTicket?.title}}
        </label>
        <div class="detail-actions">
          <button class="v-btn btn btn-primary vsight-button create-button me-3" (click)="openTicketExportModal()">{{ 'MAIN.CONTENT.TICKETS.EXPORT_PDF.BUTTON' | translate }}</button>
          <button class="v-btn btn btn-primary vsight-button create-button me-3" (click)="deleteTicket()">{{ 'MAIN.CONTENT.TICKETS.DELETE' | translate }}</button>
          <button class="v-btn btn btn-primary vsight-button create-button" (click)="editTicket()">{{ 'MAIN.CONTENT.TICKETS.EDIT' | translate }}</button>
        </div>
      </div>
    }
  </div>

  <!-- Tab Navigation -->
  @if (viewMode && mode !== 'create') {
    <div>
      <div class="card tab-area d-flex flex-row first-area">
        <div class="tab-item left fs-16 font-weight-600 ms-4" [ngClass]="{'selected-tab' : tabIndex == 0 }" (click)="onTabClicked(0)">
          <span class="tab-title">
            {{ 'MAIN.CONTENT.TICKETS.CHAT_TIMELINE.TITLE' | translate }}
          </span>
        </div>
        <div class="tab-item fs-16 font-weight-600 ms-4" [ngClass]="{'selected-tab' : tabIndex == 1 }" (click)="onTabClicked(1)">
          <span class="tab-title">
            {{ 'MAIN.CONTENT.TICKETS.DETAILS' | translate }}
          </span>
        </div>
        <div class="tab-item fs-16 font-weight-600 ms-4" [ngClass]="{'selected-tab' : tabIndex == 2 }" (click)="onTabClicked(2)">
          <span class="tab-title">
            {{ 'MAIN.CONTENT.TICKETS.ATTACHED_SESSIONS' | translate }}
          </span>
        </div>
        <div class="tab-item right fs-16 font-weight-600 ms-4" [ngClass]="{'selected-tab' : tabIndex == 3 }" (click)="onTabClicked(3)">
          <span class="tab-title">
            {{ 'MAIN.CONTENT.TICKETS.FILES.TITLE' | translate }}
          </span>
        </div>
      </div>
    </div>
  }

  <!-- Tab Navigation for Create Mode -->
  @if (mode === 'create') {
    <div>
      <div class="card tab-area d-flex flex-row first-area">
        <div class="tab-item left fs-16 font-weight-600 ms-4" [ngClass]="{'selected-tab' : tabIndex == 1 }" (click)="onTabClicked(1)">
          <span class="tab-title">
            {{ 'MAIN.CONTENT.TICKETS.DETAILS' | translate }}
          </span>
        </div>
        <div class="tab-item right fs-16 font-weight-600 ms-4" [ngClass]="{'selected-tab' : tabIndex == 3 }" (click)="onTabClicked(3)">
          <span class="tab-title">
            {{ 'MAIN.CONTENT.TICKETS.FILES.TITLE' | translate }}
          </span>
        </div>
      </div>
    </div>
  }

  @if (!isLoadingDetail) {
    <!-- Tab 0: Chat+Timeline -->
    @if (tabIndex == 0 && viewMode) {
      <app-ticket-chat-timeline
        [ticketId]="$safeNavigationMigration(selectedTicket?.id)"
        [sessions]="ticketSessions"
        [files]="files"
        [users]="selectedTicketRoomUsers"
        (navigateToTab)="onTabClicked($event)"
        (sessionSelected)="onTimelineSessionSelected($event)"
        (fileUploaded)="refreshFiles()">
      </app-ticket-chat-timeline>
    }
    <!-- Tab 1: Ticket Details -->
    @if (tabIndex == 1 || (tabIndex == 0 && !viewMode)) {
      <div class="content-area" [ngClass]="{'no-top-padding': viewMode || mode === 'create'}">
        <div class="order-wrapper d-flex flex-column align-items-center">
          @if (!viewMode) {
            <div class="d-flex align-items-center w-100 mb-4">
              <label class="fs-14 font-weight-600" style="width: 122px;">{{ 'MAIN.CONTENT.TICKETS.TICKET_TITLE' | translate }}</label>
              <div class="d-flex flex-column flex-grow-1 ms-3 field-counter-container field-counter-input">
                <input type="text" class="form-control fs-14" formControlName="title"
                  [ngClass]="{'is-invalid': title.invalid && title.touched, 'required-highlight': title.invalid && title.touched}" maxlength="100"
                  (input)="enforceMaxLength('title', 100)" (paste)="guardPaste($event, 'title', 100)"
                  (focus)="setFocusedField('title')" (blur)="setFocusedField(null)">
                @if (title.errors && title.errors['required']) {
                  <small class="invalid-feedback">{{ 'MAIN.CONTENT.TICKETS.TITLE_REQUIRED' | translate }}</small>
                }
                @if (!viewMode && shouldShowCounter('title', 100)) {
                  <small class="char-counter"
                    [ngClass]="getCounterClass('title', 100)">
                    {{ formatCount(getCharCount('title')) }} / {{ formatCount(100) }}
                  </small>
                }
              </div>
            </div>
          }
          <div class="d-flex align-items-center w-100 mb-4">
            <label class="fs-14 font-weight-600" style="width: 122px;">{{ 'MAIN.CONTENT.TICKETS.STATUS' | translate }}</label>
            <div class="btn-group dropdown-wrapper-list status-wrapper-list ps-0 pe-0 ms-3" dropdown style="width: 180px;border: none;">
              <button type="button" class="btn btn-primary action-dropdown status-dropdown {{status.value}} p-0 text-start ps-2 hover-style fs-15" #toggleButton dropdownToggle>
                <img src="assets/img/{{status.value}}.svg" alt="" class="status-dropdown-icon">
                {{ 'MAIN.CONTENT.TICKETS.STATUS_' + (status.value | uppercase) | translate }}
              </button>
              <button id="button-split" type="button" class="btn dropdown-toggle dropdown-toggle-split status-toggle {{status.value}}" (click)="$event.stopPropagation(); toggleButton.click()"
                aria-controls="dropdown-split">
              </button>
                    <ul id="dropdown-split" *dropdownMenu class="dropdown-menu" role="menu" style="max-height: 240px; 
                    overflow-y: scroll; min-width: 130px;" aria-labelledby="dropdownMenuClickableInside">
                @for (ticketStatus of ticketStatuses; track ticketStatus) {
                  <li role="menuitem">
                    <a class="dropdown-item fs-14 lato-regular" (click)="changeStatus(ticketStatus.id)">
                      {{ 'MAIN.CONTENT.TICKETS.STATUS_' + (ticketStatus.id | uppercase) | translate }}
                    </a>
                  </li>
                }
              </ul>
            </div>
          </div>
          <div class="d-flex align-items-center w-100 mb-4">
            <label class="fs-14 font-weight-600" style="width: 122px;">{{ 'MAIN.CONTENT.TICKETS.PRIORITY' | translate }}</label>
            @if (!viewMode) {
              <div class="btn-group dropdown-wrapper-list priority-wrapper-list ps-0 pe-0 ms-3" dropdown style="width: 180px;border: none;">
                <button type="button" class="btn btn-primary action-dropdown priority-dropdown p-0 text-start ps-4 hover-style" #toggleButton dropdownToggle>
                  <span class="fs-20 expert-web-status {{priority.value}}">.</span>
                  {{ 'MAIN.CONTENT.TICKETS.PRIORITY_' + (priority.value | uppercase) | translate }}
                </button>
                <button id="button-split" type="button" class="btn dropdown-toggle dropdown-toggle-split priority-toggle" (click)="$event.stopPropagation(); toggleButton.click()"
                  aria-controls="dropdown-split">
                </button>
                    <ul id="dropdown-split" *dropdownMenu class="dropdown-menu" role="menu" style="max-height: 240px; 
                    overflow-y: scroll; min-width: 110px;" aria-labelledby="dropdownMenuClickableInside">
                  @for (ticketPriority of ticketPriorities; track ticketPriority) {
                    <li role="menuitem">
                      <a class="dropdown-item fs-15 position-relative priority-item" (click)="changePriority(ticketPriority.id)">
                        <span class="fs-20 status-list-item {{ticketPriority.id}}">.</span>
                        {{ 'MAIN.CONTENT.TICKETS.PRIORITY_' + (ticketPriority.id | uppercase) | translate }}
                      </a>
                    </li>
                  }
                </ul>
              </div>
            }
            @if (viewMode) {
              <div class="fs-14 lato-regular p-relative ms-3">
                <span class="fs-20 priority-status {{priority.value}}">.</span>
                <span class="ps-3">{{ 'MAIN.CONTENT.TICKETS.PRIORITY_' + (priority.value | uppercase) | translate }}</span>
              </div>
            }
          </div>
          <div class="d-flex align-items-center w-100 mb-4">
            <label class="fs-14 font-weight-600" style="width: 122px;">{{ 'MAIN.CONTENT.TICKETS.WORK_GROUP' | translate }}</label>
            @if (!viewMode) {
              <div class="d-flex flex-column flex-grow-1 ms-3">
                <ng-select [items]="rooms" name="room_id" bindLabel="name" bindValue="id"
                  formControlName="room_id"
                  [ngClass]="{'is-invalid': roomId?.invalid && roomId?.touched, 'required-highlight': roomId?.invalid && roomId?.touched}">
                </ng-select>
                @if (roomId?.invalid && roomId?.touched) {
                  <small class="invalid-feedback">
                    {{ 'MAIN.CONTENT.TICKETS.FORM_INVALID' | translate }}
                  </small>
                }
              </div>
            }
            @if (viewMode) {
              <div class="fs-14 lato-regular ms-3">
                {{ getRoomName($safeNavigationMigration(selectedTicket?.room_id)) }}
              </div>
            }
          </div>
          <div class="d-flex align-items-center w-100 mb-4">
            <label class="fs-14 font-weight-600" style="width: 122px;">{{ 'MAIN.CONTENT.TICKETS.TYPE' | translate }}</label>
            @if (!viewMode) {
              <ng-select [items]="ticketTypes" name="type" bindLabel="name" bindValue="id"
                formControlName="type" class="ms-3" style="flex: 1;">
              </ng-select>
            }
            @if (viewMode) {
              <div class="fs-14 lato-regular ms-3">
                {{ getTicketTypeName($safeNavigationMigration(ticketForm.get('type')?.value)) }}
              </div>
            }
          </div>
          <div class="d-flex align-items-center w-100 mb-4">
            <label class="fs-14 font-weight-600" style="width: 122px;">{{ 'MAIN.CONTENT.TICKETS.ASSIGNEE' | translate }}</label>
            @if (!viewMode) {
              <ng-select [items]="selectedTicketRoomUsers" name="assignee" bindLabel="name" bindValue="id"
                formControlName="assignee" class="ms-3" style="flex: 1;"
                [clearable]="true" placeholder="{{ 'MAIN.CONTENT.TICKETS.ASSIGNEE' | translate }}">
              </ng-select>
            }
            @if (viewMode && ticketForm.get('assignee')?.value) {
              <div class="fs-14 lato-regular ms-3">
                {{ getUsersName($safeNavigationMigration(ticketForm.get('assignee')?.value)) }}
              </div>
            }
            @if (viewMode && !ticketForm.get('assignee')?.value) {
              <div class="fs-14 lato-regular text-grey ms-3">
                -
              </div>
            }
          </div>
          <div class="d-flex align-items-center w-100 mb-4">
            <label class="fs-14 font-weight-600" style="width: 122px;">{{ 'MAIN.CONTENT.TICKETS.FOLLOWUP_DATE' | translate }}</label>
            @if (!viewMode) {
              <div class="d-flex align-items-center lato-regular ms-3" style="height: 90%;">
                <input #followupDate="bsDatepicker" formControlName="followup" name="followupDate" class="form-control fs-14" style="width: 178px;" bsDatepicker
                  autocomplete="off"
                  [bsConfig]="followupDateConfig" onkeypress="return false;">
                <span style="margin-left: -25px; margin-bottom: 4px;">
                  <img src="assets/img/calendar-icon.svg" style="height: 17px;">
                </span>
              </div>
            }
            @if (viewMode && selectedTicket?.followup) {
              <div class="fs-14 lato-regular ms-3">
                {{ selectedTicket.followup | date: 'dd-MM-yyyy' }}
              </div>
            }
            @if (viewMode && !selectedTicket?.followup) {
              <div class="fs-14 lato-regular text-grey ms-3">
                -
              </div>
            }
          </div>
          @if (selectedTicket) {
            <div class="d-flex align-items-center w-100">
              <label class="fs-14 font-weight-600" style="width: 122px;">{{ 'MAIN.CONTENT.TICKETS.CREATED_ON' | translate }}</label>
              <label class="fs-14 lato-regular ms-3">{{ formatTimestamp(selectedTicket.create_time) }}</label>
            </div>
          }
        </div>
        <div class="order-wrapper align-items-center field-counter-container field-counter-textarea">
          <label class="fs-14 font-weight-600 mb-3">{{ 'MAIN.CONTENT.TICKETS.DESCRIPTION' | translate }}</label>
          @if (!viewMode) {
            <textarea name="" id="" cols="30" rows="5" class="form-control fs-14"
              [ngClass]="{'over-limit': getCharCount('description') > 5000}"
              (focus)="setFocusedField('description')" (blur)="setFocusedField(null)"
            formControlName="description"></textarea>
          }
          @if (viewMode) {
            <p class="fs-14 lato-regular mb-0">{{ selectedTicket?.description || '-' }}</p>
          }
          @if (!viewMode && shouldShowCounter('description', 5000)) {
            <small class="char-counter"
              [ngClass]="getCounterClass('description', 5000)">
              {{ getCounterText('description', 5000) }}
            </small>
          }
        </div>
        <div class="order-wrapper align-items-center field-counter-container field-counter-textarea">
          <label class="fs-14 font-weight-600 mb-3">{{ 'MAIN.CONTENT.TICKETS.RESOLUTION' | translate }}</label>
          @if (!viewMode) {
            <textarea name="" id="" cols="30" rows="4" class="form-control fs-14"
              [ngClass]="{'over-limit': getCharCount('resolution') > 10000}"
              (focus)="setFocusedField('resolution')" (blur)="setFocusedField(null)"
            formControlName="resolution"></textarea>
          }
          @if (viewMode) {
            <p class="fs-14 lato-regular mb-0">{{ selectedTicket?.resolution || '-' }}</p>
          }
          @if (!viewMode && shouldShowCounter('resolution', 10000)) {
            <small class="char-counter"
              [ngClass]="getCounterClass('resolution', 10000)">
              {{ getCounterText('resolution', 10000) }}
            </small>
          }
        </div>
      </div>
    }
    <!-- End Tab 1 -->
    <!-- Tab 2: Attached Sessions -->
    @if (tabIndex == 2 && viewMode) {
      <div class="order-wrapper py-3 mb-3 bg-white d-flex align-items-center justify-content-between attached-sessions-header">
        <div class="fs-16 font-weight-600">{{ 'MAIN.CONTENT.TICKETS.ATTACHED_SESSIONS' | translate }}</div>
        <button class="v-btn btn btn-primary vsight-button" (click)="onAttachSession()">
          {{ 'MAIN.CONTENT.TICKETS.ADD_SESSION' | translate }}
        </button>
      </div>
      <!-- Session Statistics -->
      @if (sessionStats) {
        <div class="order-wrapper py-3 mb-3 bg-white">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-6 mt-2 fs-14">
                <span class="font-weight-600">{{ 'MAIN.CONTENT.TICKETS.SESSION_COUNT' | translate }}: </span>
                <span>{{ sessionStats.count }}</span>
              </div>
              <div class="col-md-6 mt-2 fs-14">
                <span class="font-weight-600">{{ 'MAIN.CONTENT.TICKETS.TOTAL_DURATION' | translate }}: </span>
                <span>{{ sessionStats.duration }}</span>
              </div>
              @if (sessionStats.users && (sessionStats.users | keyvalue).length > 0) {
                <div class="col-12 my-2">
                  <div class="font-weight-600 my-2 fs-14">{{ 'MAIN.CONTENT.TICKETS.PARTICIPANTS' | translate }}:</div>
                  <div class="row">
                    @for (user of (sessionStats.users | keyvalue); track user) {
                      <div class="col-md-6 mt-1 fs-14">
                        <span class="font-weight-600">{{ getUsersName($any(user.key)) }}: </span>
                        <span>{{ $any(user.value).count }} {{ 'MAIN.CONTENT.TICKETS.SESSIONS' | translate }}</span>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }
      <!-- Sessions Table -->
      <div class="order-wrapper px-3 mb-2">
        <div class="table-responsive">
          <table class="table table-hover fs-14">
            <thead>
              <tr>
                <th scope="col" class="font-weight-bold">#</th>
                <th scope="col" class="font-weight-bold">{{ 'MAIN.CONTENT.TICKETS.DATE' | translate }} ({{ timezone }})</th>
                <th scope="col" class="font-weight-bold">{{ 'MAIN.CONTENT.TICKETS.ROOM_NAME' | translate }}</th>
                <th scope="col" class="font-weight-bold">{{ 'MAIN.CONTENT.TICKETS.PARTICIPANTS' | translate }}</th>
                <th scope="col" class="font-weight-bold">{{ 'MAIN.CONTENT.TICKETS.DURATION' | translate }}</th>
                @if (isExpert || isAdmin) {
                  <th scope="col" class="font-weight-bold"></th>
                }
              </tr>
            </thead>
            <tbody>
              @if (ticketSessions && ticketSessions.length === 0) {
                <tr>
                  <td colspan="6" class="text-center text-muted py-3">
                    {{ 'MAIN.CONTENT.TICKETS.NO_ATTACHED_SESSIONS' | translate }}
                  </td>
                </tr>
              }
              @for (session of ticketSessions; track session; let i = $index) {
                <tr class="cursor-pointer attached-session-row"
                  [ngClass]="{ 'attached-session-selected': selectedSessionId === session.id }"
                  (click)="onAttachedSessionRowClick(session)">
                  <td>{{ i + 1 }}</td>
                  <td>{{ formatTimestamp(session.create_time) }}</td>
                  <td>{{ getRoomName(session.room_id) }}</td>
                  <td>
                    @for (uid of session.users | getIds | filterGuests:session.guest_users; track uid) {
                      <div class="mt-1">
                        {{ getUsersName(uid) }}
                      </div>
                    }
                    @for (guest of session.guest_users | objectToArray; track guest) {
                      <div class="mt-1">
                        {{ guest.name }} <span class="text-info">({{ 'MAIN.CONTENT.TICKETS.GUEST' | translate }})</span>
                      </div>
                    }
                  </td>
                  <td>
                    @if (session.start_time && session.end_time) {
                      <span>
                        {{ getDuration(session.start_time, session.end_time) }} min
                      </span>
                    }
                    @if (!session.start_time || !session.end_time) {
                      <span>-</span>
                    }
                  </td>
                  @if (isExpert || isAdmin) {
                    <td class="text-end detach-cell">
                      <img src="assets/img/close-circle.svg" alt=""
                        class="detach-session-icon"
                        (click)="onDetachSession(session); $event.stopPropagation()"
                        title="{{ 'MAIN.CONTENT.TICKETS.DETACH_SESSION' | translate }}">
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }
    <!-- End Tab 2 -->
    <!-- Tab 3: Files -->
    @if (tabIndex == 3 && (viewMode || mode === 'create')) {
      <div class="order-wrapper px-3 mb-2">
        <!-- Loading state for view mode -->
        @if (isLoadingFiles && viewMode) {
          <div class="d-flex justify-content-center align-items-center py-5">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        }
        @if (!isLoadingFiles || mode === 'create') {
          <div>
            <!-- Upload area for view mode (existing ticket) -->
            @if (viewMode) {
              <div class="ticket-upload-area">
                <input type="file" class="d-none" (change)="onChooseTicketFiles($event)" onclick="this.value = null" #ticketFileInput multiple>
                <div class="upload-drop-zone" filedrop [fileType]="'video/*,image/*,application/pdf,audio/*'" (filesDropped)="dragDropUpload($event)" accept="*" id="ticket-drop-zone">
                  <div class="upload-icon mt-3"><img src="assets/img/upload-icon.svg" alt=""></div>
                  <div class="fs-14 font-weight-700 top-gap-8">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.WIDGET-PROPERTIES.IMAGE.UPLOAD.DRAG-DROP' | translate }}</div>
                  <div class="fs-14 text-dark-grey">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.WIDGET-PROPERTIES.IMAGE.UPLOAD.INFORM' | translate }}</div>
                  <div class="upload-button mb-4 mt-1">
                    @if (!('electron' | env)) {
                      <button class="vsight-button v-btn btn btn-primary top-gap-12 font-weight-600 mb-2" (click)="ticketFileInput.click()">
                        {{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-DETAIL.UPLOAD-FILE' | translate }}
                      </button>
                    }
                  </div>
                </div>
              </div>
            }
            <!-- Upload area for create mode -->
            @if (mode === 'create') {
              <div class="ticket-upload-area">
                <input type="file" class="d-none" (change)="onChooseCreateFiles($event)" onclick="this.value = null" #createFileInput multiple>
                <div class="upload-drop-zone" filedrop [fileType]="'video/*,image/*,application/pdf,audio/*'" (filesDropped)="dragDropCreateFiles($event)" accept="*" id="create-drop-zone">
                  <div class="upload-icon mt-3"><img src="assets/img/upload-icon.svg" alt=""></div>
                  <div class="fs-14 font-weight-700 top-gap-8">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.WIDGET-PROPERTIES.IMAGE.UPLOAD.DRAG-DROP' | translate }}</div>
                  <div class="fs-14 text-dark-grey">{{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-STEPS.WIDGET-PROPERTIES.IMAGE.UPLOAD.INFORM' | translate }}</div>
                  <div class="upload-button mb-4 mt-1">
                    @if (!('electron' | env)) {
                      <button class="vsight-button v-btn btn btn-primary top-gap-12 font-weight-600 mb-2" (click)="createFileInput.click()">
                        {{ 'MAIN.CONTENT.WORKFLOW.WORKFLOW-DETAIL.UPLOAD-FILE' | translate }}
                      </button>
                    }
                  </div>
                </div>
              </div>
            }
            <!-- Existing files (view mode) -->
            @if (viewMode && files.length > 0) {
              <div class="ticket-files-grid">
                @for (file of files; track file; let i = $index) {
                  <div class="ticket-file-item">
                    @if (isImageFile(file)) {
                      <div class="ticket-file-preview cursor-pointer" (click)="onFilePreview(file)">
                        <img [src]="file.url" alt="">
                      </div>
                    }
                    @if (!isImageFile(file) && pdfExtensions.includes(file.extension)) {
                      <div class="ticket-file-preview cursor-pointer" (click)="onFilePreview(file)">
                        <img src="assets/img/pdf.png" alt="">
                      </div>
                    }
                    @if (!isImageFile(file) && !pdfExtensions.includes(file.extension)) {
                      <div class="ticket-file-preview cursor-pointer" (click)="onFilePreview(file)">
                        <img src="assets/img/other.png" alt="">
                      </div>
                    }
                    <div class="file-badge d-flex align-items-center fs-14">
                      <a class="file-attach" (click)="onDownloadFile(file)">
                        <img src="assets/img/download-step-file.svg" alt="" class="download-file">
                      </a>
                      <label class="fs-14 font-weight-400 file-name" [title]="file.name">{{ file.name }}</label>
                      @if (isExpert || isAdmin) {
                        <img src="assets/img/close.svg" alt="" class="close-file" (click)="onDeleteFile(file)">
                      }
                    </div>
                  </div>
                }
              </div>
            }
            <!-- Pending files (create mode) -->
            @if (mode === 'create' && pendingFiles.length > 0) {
              <div class="ticket-files-grid">
                @for (file of pendingFiles; track file; let i = $index) {
                  <div class="ticket-file-item">
                    @if (isPendingImageFile(file)) {
                      <div class="ticket-file-preview">
                        <img [src]="getPendingFileUrl(file)" alt="">
                      </div>
                    }
                    @if (!isPendingImageFile(file) && isPendingPdfFile(file)) {
                      <div class="ticket-file-preview">
                        <img src="assets/img/pdf.png" alt="">
                      </div>
                    }
                    @if (!isPendingImageFile(file) && !isPendingPdfFile(file)) {
                      <div class="ticket-file-preview">
                        <img src="assets/img/other.png" alt="">
                      </div>
                    }
                    <div class="file-badge d-flex align-items-center fs-14">
                      <label class="fs-14 font-weight-400 file-name" [title]="file.name">{{ file.name }}</label>
                      <img src="assets/img/close.svg" alt="" class="close-file" (click)="removePendingFile(i)">
                    </div>
                  </div>
                }
              </div>
            }
            <!-- No files message (view mode) -->
            @if (viewMode && files.length === 0) {
              <div class="text-center py-5 text-muted">
                <p class="fs-14">{{ 'MAIN.CONTENT.TICKETS.FILES.NO_FILES' | translate }}</p>
              </div>
            }
            <!-- No files message (create mode) -->
            @if (mode === 'create' && pendingFiles.length === 0) {
              <div class="text-center py-5 text-muted">
                <p class="fs-14">{{ 'MAIN.CONTENT.TICKETS.FILES.NO_FILES' | translate }}</p>
              </div>
            }
          </div>
        }
      </div>
    }
    <!-- End Tab 3 -->
  }

</div>

<ng-template #pickSessionTemplate let-dataModel="dataModel" let-callbacks="callbacks">
  <div class="modal-dialog modal-xl modal-dialog-centered session-picker-dialog" role="document">
    <div class="modal-content">
      <div class="v-card session-picker-modal" [ngClass]="{ 'drawer-open': quickSession }">
        <div class="modal-header d-flex align-items-center justify-content-between">
          <div class="modal-title font-weight-600">{{ 'MAIN.SESSIONS.SESSION_DETAILS.ATTACH_SESSION_TO_TICKET' | translate }}</div>
          <div class="cursor-pointer" (click)="callbacks.close()">
            <img src="assets/img/close_white.svg" alt="">
          </div>
        </div>
        <div class="card-body">
          <div class="m-body session-list-wrapper">
            @if (dataModel.loading) {
              <div class="session-list-loading">
                <div class="loader loader-sm la-dark">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            }

            @if (!dataModel.loading) {
              <div class="user-table-header d-flex align-items-center">
                <div class="col-1 fs-14 font-weight-400 text-dark-grey">#</div>
                <div class="col-3 fs-14 font-weight-400 text-dark-grey">{{ 'MAIN.CONTENT.TICKETS.DATE' | translate }} ({{ timezone }})</div>
                <div class="col-4 fs-14 font-weight-400 text-dark-grey">{{ 'MAIN.CONTENT.TICKETS.PARTICIPANTS' | translate }}</div>
                <div class="col-2 fs-14 font-weight-400 text-dark-grey">{{ 'MAIN.CONTENT.TICKETS.DURATION' | translate }}</div>
                <div class="col-2 fs-14 font-weight-400 text-dark-grey"></div>
              </div>
              @if (dataModel.sessions.length === 0) {
                <div class="session-list-empty">
                  {{ 'MAIN.CONTENT.TICKETS.NO_SESSIONS' | translate }}
                </div>
              }
              @for (session of dataModel.sessions; track session; let i = $index) {
                <div class="workflow-card d-flex align-items-center cursor-pointer"
                  [ngClass]="{ 'selected': selectedSessionId === session.id, 'selected-attached': isSessionAttached(session.id) }"
                  (click)="onSessionPicked(session.id)">
                  <div class="col-1 fs-14 font-weight-400 text-light-black">{{ i + 1 }}</div>
                  <div class="col-3 fs-14 font-weight-400 text-light-black">{{ formatTimestamp(session.create_time) }}</div>
                  <div class="col-4 fs-14 font-weight-400 text-light-black">
                    @if (isUserListArray(session.users)) {
                      @for (user of session.users; track user) {
                        <div class="mt-1">
                          {{ user?.name || getUsersName($safeNavigationMigration(user?.id)) }}
                        </div>
                      }
                    } @else {
                      @for (uid of session.users | getIds | filterGuests:session.guest_users; track uid) {
                        <div class="mt-1">
                          {{ getUsersName(uid) }}
                        </div>
                      }
                    }
                    <ng-template #userIdsTemplate>
                      @for (uid of session.users | getIds | filterGuests:session.guest_users; track uid) {
                        <div class="mt-1">
                          {{ getUsersName(uid) }}
                        </div>
                      }
                    </ng-template>
                    @for (guest of session.guest_users | objectToArray; track guest) {
                      <div class="mt-1">
                        {{ guest.name }} <span class="text-info">({{ 'MAIN.CONTENT.TICKETS.GUEST' | translate }})</span>
                      </div>
                    }
                  </div>
                  <div class="col-2 fs-14 font-weight-400 text-light-black">
                    @if (session.start_time && session.end_time) {
                      <span>
                        {{ getDuration(session.start_time, session.end_time) }} min
                      </span>
                    }
                    @if (!session.start_time || !session.end_time) {
                      <span>-</span>
                    }
                  </div>
                  <div class="col-2 d-flex justify-content-end">
                    <button type="button" class="v-btn btn btn-primary-outline vsight-button-outline-primary" (click)="openQuickSession(session); $event.stopPropagation()">
                      {{ 'MAIN.CONTENT.TICKETS.DETAILS' | translate }}
                    </button>
                  </div>
                </div>
              }
            }
          </div>
          @if (quickSession) {
            <div class="session-quick-drawer">
              <div class="drawer-header d-flex justify-content-between align-items-center">
                <div class="fs-15 font-weight-600">{{ 'MAIN.CONTENT.TICKETS.DETAILS' | translate }}</div>
                <button type="button" class="btn btn-link p-0" (click)="closeQuickSession()">
                  <img src="assets/img/close.svg" alt="">
                </button>
              </div>
              <div class="drawer-body">
                <div class="drawer-row">
                  <span class="label">{{ 'MAIN.CONTENT.TICKETS.DATE' | translate }} ({{ timezone }})</span>
                  <span class="value">{{ formatTimestamp(quickSession.create_time) }}</span>
                </div>
                <div class="drawer-row">
                  <span class="label">{{ 'MAIN.CONTENT.TICKETS.ROOM_NAME' | translate }}</span>
                  <span class="value">{{ getSessionRoomName(quickSession) }}</span>
                </div>
                <div class="drawer-row">
                  <span class="label">{{ 'MAIN.CONTENT.TICKETS.DURATION' | translate }}</span>
                  <span class="value">
                    @if (quickSession.start_time && quickSession.end_time) {
                      {{ getDuration(quickSession.start_time, quickSession.end_time) }} min
                    } @else {
                      -
                    }
                    <ng-template #noDuration>-</ng-template>
                  </span>
                </div>
                <div class="drawer-row">
                  <span class="label">{{ 'MAIN.CONTENT.TICKETS.PARTICIPANTS' | translate }}</span>
                  <div class="value">
                    @if (isUserListArray(quickSession.users)) {
                      @for (user of quickSession.users; track user) {
                        <div class="mt-1">
                          {{ user?.name || getUsersName($safeNavigationMigration(user?.id)) }}
                        </div>
                      }
                    } @else {
                      @for (uid of quickSession.users | getIds | filterGuests:quickSession.guest_users; track uid) {
                        <div class="mt-1">
                          {{ getUsersName(uid) }}
                        </div>
                      }
                    }
                    <ng-template #quickUserIdsTemplate>
                      @for (uid of quickSession.users | getIds | filterGuests:quickSession.guest_users; track uid) {
                        <div class="mt-1">
                          {{ getUsersName(uid) }}
                        </div>
                      }
                    </ng-template>
                    @for (guest of quickSession.guest_users | objectToArray; track guest) {
                      <div class="mt-1">
                        {{ guest.name }} <span class="text-info">({{ 'MAIN.CONTENT.TICKETS.GUEST' | translate }})</span>
                      </div>
                    }
                  </div>
                </div>
                <div class="drawer-section">
                  <div class="section-title">{{ 'MAIN.SESSIONS.SESSION_DETAILS.FILES' | translate }}</div>
                  @if (quickFilesLoading) {
                    <div class="section-loading">
                      <div class="spinner-border text-primary" role="status"></div>
                    </div>
                  }
                  @if (!quickFilesLoading && quickFiles.length === 0) {
                    <div class="section-empty">
                      {{ 'MAIN.SESSIONS.SESSION_FILES.NO_FILE_IS_ADDED' | translate }}
                    </div>
                  }
                  @if (!quickFilesLoading && quickFiles.length > 0) {
                    <div class="file-list">
                      @for (file of quickFiles; track file) {
                        <div class="file-row">
                          <div class="file-icon">
                            <img [src]="getQuickFileIcon(file)" alt="">
                          </div>
                          <div class="file-meta">
                            <div class="file-name" [title]="file.name">{{ file.name }}</div>
                            @if (file.size) {
                              <div class="file-size">{{ file.size | fileSize }}</div>
                            }
                          </div>
                          <div class="file-actions">
                            @if (isQuickPreviewable(file)) {
                              <button type="button" class="btn btn-link p-0 me-2" (click)="onQuickFilePreview(file)">
                                <img src="assets/img/open.svg" alt="">
                              </button>
                            }
                            <button type="button" class="btn btn-link p-0" (click)="onQuickFileDownload(file)">
                              <img src="assets/img/download-step-file.svg" alt="">
                            </button>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
                <div class="drawer-section">
                  <div class="section-title">{{ 'MAIN.ARCHIVES.ARCHIVE_LIST.ARCHIVES' | translate }}</div>
                  @if (quickArchivesLoading) {
                    <div class="section-loading">
                      <div class="spinner-border text-primary" role="status"></div>
                    </div>
                  }
                  @if (!quickArchivesLoading && quickArchives.length === 0) {
                    <div class="section-empty">
                      {{ 'MAIN.ARCHIVES.ARCHIVE_LIST.NO_ARCHIVE_MESSAGE' | translate }}
                    </div>
                  }
                  @if (!quickArchivesLoading && quickArchives.length > 0) {
                    <div class="archive-list">
                      @for (archive of quickArchives; track archive) {
                        <div class="archive-row">
                          <div class="archive-meta">
                            <div class="archive-name" [title]="archive.name">{{ archive.name || '-' }}</div>
                            <div class="archive-info">
                              @if (archive.duration) {
                                <span>{{ archive.duration }}s</span>
                              }
                              @if (archive.size) {
                                <span>{{ archive.size | fileSize }}</span>
                              }
                            </div>
                          </div>
                          <div class="archive-status">
                            <span [class]="getArchiveBadgeClass(archive)">{{ getArchiveStatusKey(archive) | translate }}</span>
                          </div>
                          <div class="archive-actions">
                            <button type="button" class="btn btn-link p-0" (click)="onQuickArchiveDownload(archive)">
                              <img src="assets/img/download-step-file.svg" alt="">
                            </button>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
                <div class="drawer-section">
                  <div class="section-title">{{ 'MAIN.SESSIONS.SESSION_DETAILS.CHAT' | translate }}</div>
                  @if (quickLogsLoading) {
                    <div class="section-loading">
                      <div class="spinner-border text-primary" role="status"></div>
                    </div>
                  }
                  @if (!quickLogsLoading) {
                    <div class="chat-list">
                      @if (quickLogs.length === 0) {
                        <div class="chat-empty">-</div>
                      }
                      @for (message of quickLogs; track message) {
                        <div class="chat-item">
                          @if (message.type === 'text') {
                            <div class="chat-owner">{{ message.owner_info }}</div>
                          }
                          @if (message.type === 'text') {
                            <div class="chat-text">{{ message.content }}</div>
                          }
                          @if (message.type !== 'text') {
                            <div class="chat-system">
                              {{ getQuickMessageTranslationKey(message) | translate:message }}
                              @if (message.extra) {
                                <span> - {{ message.extra }}</span>
                              }
                            </div>
                          }
                          <div class="chat-time text-muted">{{ message.create_time | date:'HH:mm' }}</div>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          }
          <div class="m-footer d-flex justify-content-center">
            <button type="button" class="v-btn vsight-button left btn vsight-button-outline-secondary btn-outline-secondary" (click)="callbacks.close()">
              {{ 'MAIN.SESSIONS.SESSION_DETAILS.CLOSE' | translate }}
            </button>
            <button type="button" class="v-btn vsight-button btn btn-primary" [disabled]="!selectedSessionId || isSelectedSessionAlreadyAttached()" (click)="selectedSessionId ? callbacks.attach() : null">
              {{ 'MAIN.SESSIONS.SESSION_DETAILS.ATTACH' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #ticketExportTemplate>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">{{ 'MAIN.CONTENT.TICKETS.EXPORT_PDF.TITLE' | translate }}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="closeTicketExportModal()"></button>
    </div>
    <div class="modal-body">
      <div class="export-subtitle">{{ 'MAIN.CONTENT.TICKETS.EXPORT_PDF.SUBTITLE' | translate }}</div>
      <div class="export-section-title">{{ 'MAIN.CONTENT.TICKETS.EXPORT_PDF.SECTION_INCLUDE' | translate }}</div>
      <div class="form-check export-option">
        <input class="form-check-input" type="checkbox" id="ticket-export-sessions" [(ngModel)]="exportOptions.includeSessions">
        <label class="form-check-label" for="ticket-export-sessions">
          {{ 'MAIN.CONTENT.TICKETS.EXPORT_PDF.ATTACHED_SESSIONS' | translate }}
        </label>
      </div>
      <div class="form-check export-option">
        <input class="form-check-input" type="checkbox" id="ticket-export-files" [(ngModel)]="exportOptions.includeFiles">
        <label class="form-check-label" for="ticket-export-files">
          {{ 'MAIN.CONTENT.TICKETS.EXPORT_PDF.FILES' | translate }}
        </label>
      </div>
      <div class="form-check export-option">
        <input class="form-check-input" type="checkbox" id="ticket-export-chat" [(ngModel)]="exportOptions.includeChat">
        <label class="form-check-label" for="ticket-export-chat">
          {{ 'MAIN.CONTENT.TICKETS.EXPORT_PDF.CHAT' | translate }}
        </label>
      </div>
      @if (exportOptions.includeFiles) {
        <div class="form-check ms-4 export-option">
          <input class="form-check-input" type="checkbox" id="ticket-export-images" [(ngModel)]="exportOptions.includeImagesInPdf">
          <label class="form-check-label" for="ticket-export-images">
            {{ 'MAIN.CONTENT.TICKETS.EXPORT_PDF.IMAGES_IN_PDF' | translate }}
          </label>
          @if (exportOptions.includeImagesInPdf) {
            <div class="export-inline-helper">
              <span class="export-info" aria-hidden="true">&#9432;</span>
              <span class="export-inline-text">{{ 'MAIN.CONTENT.TICKETS.EXPORT_PDF.IMAGES_OPTIMIZED' | translate }}</span>
            </div>
          }
        </div>
      }
      <div class="export-section-title mt-3">{{ 'MAIN.CONTENT.TICKETS.EXPORT_PDF.SECTION_OUTPUT' | translate }}</div>
      <div class="export-output-box">
        <div class="export-helper">
          <span class="text-muted">{{ 'MAIN.CONTENT.TICKETS.EXPORT_PDF.OUTPUT_FORMAT_LABEL' | translate }}</span>
          <span class="ms-1 output-format-value">
            {{ exportOptions.includeFiles ? ('MAIN.CONTENT.TICKETS.EXPORT_PDF.OUTPUT_FORMAT_ZIP' | translate) : ('MAIN.CONTENT.TICKETS.EXPORT_PDF.OUTPUT_FORMAT_PDF' | translate) }}
          </span>
        </div>
        <div class="export-helper text-muted">
          {{ 'MAIN.CONTENT.TICKETS.EXPORT_PDF.ESTIMATED_SIZE' | translate }} <span class="output-size-value">{{ getEstimatedExportSizeLabel() }}</span>
        </div>
      </div>
      @if (exportError) {
        <div class="text-danger mt-2">
          {{ exportError }}
        </div>
      }
    </div>
    <div class="modal-footer">
      <button type="button" class="v-btn vsight-button btn vsight-button-outline-secondary btn-outline-secondary export-cancel" (click)="closeTicketExportModal()">
        {{ 'MAIN.CONTENT.TICKETS.EXPORT_PDF.CANCEL' | translate }}
      </button>
      <button type="button" class="v-btn vsight-button btn btn-primary" [disabled]="isExporting || isExportDisabled()" (click)="exportTicket()">
        @if (isExporting) {
          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        }
        {{ isExporting ? ('MAIN.CONTENT.TICKETS.EXPORT_PDF.EXPORTING' | translate) : ('MAIN.CONTENT.TICKETS.EXPORT_PDF.EXPORT' | translate) }}
      </button>
    </div>
  </div>
</ng-template>
